import { Loader } from '@zoom/components';
import React from 'react';

// eslint-disable-next-line
// @ts-ignore
import styles from '../styles/components/loadingOverlay.scss';

interface LoadingOverlayProps extends React.PropsWithChildren {
  loading: boolean;
}

// TODO: Add appropriate ARIA role/prop to Loader component
const renderedLoader = (
  <div className="loading-overlay__wrapper modal-backdrop fade in show" data-test-id="loader">
    <Loader size={40} color="#63ad1a" className="loading-overlay__loader" />
  </div>
);

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading, children }) => {
  React.useEffect(() => {
    styles?.use?.();

    return () => {
      styles?.unuse?.();
    };
  }, []);

  return (
    <>
      {children}
      {loading ? renderedLoader : null}
    </>
  );
};
